import React from 'react';
import {
  ButtonText,
  ButtonWrapper,
  ButtonsContainer,
  FacebookLinkButton,
  MemberLinkButton,
  RowWrapperLink,
} from '../styledComponent';
import Button from '../../../components/Button/Button';
import LinkAccountButtons from '../../Settings/Account/components/LinkAccount/DefaultLinkAccount';

const DynamicPopupsButtons = ({ showLinkAccountButtons, buttonsRendering, modalType, onDisplayAction }) => {
  return (
    <React.Fragment>
      {showLinkAccountButtons ? (
        <LinkAccountButtons
          rowWrapperStyles={RowWrapperLink}
          facebookLinkButtonStyles={FacebookLinkButton}
          memberLinkButtonStyles={MemberLinkButton}
          isActionCommand={true}
          modalType={modalType}
          onDisplayAction={onDisplayAction}
        />
      ) : (
        <RenderingButtons buttonsRendering={buttonsRendering} />
      )}
    </React.Fragment>
  );
};

const RenderingButtons = ({ buttonsRendering }) => {
  return (
    <ButtonsContainer>
      {buttonsRendering.map(({ label, action, imageSource }, index) => (
        <ButtonWrapper key={index} imageSource={imageSource}>
          <Button imageSource={imageSource} label={label} onClick={action} textStyle={ButtonText} />
        </ButtonWrapper>
      ))}
    </ButtonsContainer>
  );
};

export default DynamicPopupsButtons;

